<script lang="ts">
	import type { BlogOverviewPage } from '$models/Page/BlogOverviewPage';
	import BlogCard from '$components/Blog/BlogCard.svelte';
	import BlogCategorySwitcher from '$components/Blog/BlogCategorySwitcher.svelte';
	import BlogPagination from '$components/Blog/BlogPagination.svelte';

	let { page }: { page: BlogOverviewPage } = $props();
</script>

<div class="block block--padding-small variant-tint-1">
	<div class="block-container container">
		{#if page.highlight}
			<div class="blog-highlight">
				<BlogCard article={page.highlight} highlight />
			</div>
		{/if}

		<BlogCategorySwitcher
			categories={page.categories}
			selectLabel={page.layout.translations.blog.categorySelectLabel}
		/>

		{#if page.articles.length > 0}
			<div class="blog-grid">
				{#each page.articles as article}
					<BlogCard {article} />
				{/each}
			</div>
		{:else}
			<div class="block-content">
				<p>Geen blogartikelen gevonden</p>
			</div>
		{/if}

		<BlogPagination
			pagination={page.pagination}
			previousLabel={page.layout.translations.blog.paginationPreviousLabel}
			nextLabel={page.layout.translations.blog.paginationNextLabel}
		/>
	</div>
</div>

<style lang="postcss">
	.blog-highlight {
		margin-bottom: 40px;

		@media (--md) {
			margin-bottom: 64px;
		}

		@media (--xl) {
			margin-bottom: 80px;
		}
	}

	.blog-grid {
		display: grid;
		grid-template-columns: 1fr;
		gap: 24px;

		@media (--md) {
			grid-template-columns: repeat(2, 1fr);
		}

		@media (--lg) {
			grid-template-columns: repeat(3, 1fr);
			gap: 16px;
		}

		@media (--xl) {
			gap: 24px;
		}
	}
</style>
